﻿import { FIQAssist  } from "../app";
import { Injectable, Inject } from "@fiqas/angular-utils";

@Injectable({
    module: FIQAssist,
    selector: CacheService.selector
})
/**
 * Cache class, stores values as JSON in memory.
 */
export class CacheService {
    public static selector = "Cache" 
    private static cacheditems: CacheItem[] = [];

    constructor() {
    }
    
    /**
     * Get a value by key.
     * @param {string} key Key of the value to get.
     * @returns T Item from session or null if not found.
     */
    public getValue<T>(key: string): T {
        if (key) {
            var entry = CacheService.cacheditems.filter(x => x.key == key).shift();
            if (entry)
                return <T>entry.value;
            return undefined;
        }
    }

    /**
    * Store a value in the session.
    * @param  {string} key The key to store the value with.
    * @param  {T} value The value to store.
    */
    public setValue<T>(key: string, value: T) {
        if (key) {
            var entry = CacheService.cacheditems.filter(x => x.key == key).shift();
            if (entry) {
                entry.value = value;
            }
            else
                CacheService.cacheditems.push(<CacheItem>{ key: key, value: value });
        }
    }

    /**
    * Clear a value by key, or all values if key is omitted.
    * @param {string} key Optional key of value to remove.
    */
    public clear(key?: string) {
        if (key) {
            var entry = CacheService.cacheditems.filter(x => x.key == key).shift();
            if (entry) {
                entry.value = undefined;
            }
        } else {
            CacheService.cacheditems = [];
        }
    }
}

interface CacheItem {
    key: string;
    value: any;
}